export default [
     {
          path: '/ldap-config',
          name: 'LdapConfig',
          component: () => import("@/views/Page/LdapConfig/LdapConfig.vue"),
          meta: {
               title: 'LDAP Config',
               requiresAuth: true,
          },
     },
     {
          path: '/ldap-departments',
          redirect: { name: 'LdapConfig', query: { tab: 'departments' } },
     }
];
